// extracted by mini-css-extract-plugin
module.exports = {"center":"NoScriptFallback-NoScriptFallback-center-4092e2ce"};